import { useState, useEffect } from 'preact/hooks';
import { sendRequest } from '../../../../tools';

export const sendVerificationCode = (phone, setToken) => {
    setToken(null);

    const fetchCode = async () => {
      try {
        let formData = new FormData();
    		formData.append('phone', phone);
        
        const response = await sendRequest('/personal-data/send-code/', { body: formData, type: 'POST', showLoader: true });
        if (response.status === 200) {
          setToken(response.data.token);

        } else {
          throw new Error(`Status ${response.status}. Status text: ${response.statusText}`);
        }
      
      } catch (error) {
        console.error(error);
      
      } finally {
        return;
      }
    };
    
    fetchCode();
};

export const checkVerificationCode = (phone, code, token) => {

    const fetchCode = async () => {
      try {
        let formData = new FormData();
        formData.append('phone', phone);
        formData.append('code', code);
        formData.append('token', token);
        
        const response = await sendRequest('/personal-data/check-code/', { body: formData, type: 'POST', showLoader: true });
        if (response.status === 200) {
          return response.data.result;
        } else {
          throw new Error(`Status ${response.status}. Status text: ${response.statusText}`);
        }
      } catch (error) {
        console.error(error);
      } finally {
        //do nothing
      }
    };
    
    return fetchCode();
};
